export default __webpack_public_path__ + "static/award_1-d2122dcf8a5e6c9b6322e5b8ee68de9b.svg";